<template>
    <v-dialog width="600px"
              :value="value"
              @input="toggleModal"
              persistent
              scrollable
              v-if="attendeeInfo !== null">
        <v-card color="kbLight">
            <v-toolbar class="text-h6" color="kbGold" dark flat text>
                <span v-if="attendeeInfo.name">
                    {{ attendeeInfo.name }} {{ attendeeInfo.lastName }} - {{ attendeeInfo.eventTitle }}
                </span>
                <span v-else>{{ attendeeInfo.eventTitle }}</span>
                <v-spacer></v-spacer>
                <v-btn text
                       color="white"
                       icon
                       @click="toggleModal(false)">
                    <v-icon>clear</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text class="pa-0 ma-0" v-if="!loadingAttendee && attendeeInfo">
                <v-tabs v-model="tab"
                        background-color="kbLight"
                        grow>
                    <v-tab class="text-capitalize font-weight-medium kbDarkBlueText--text">
                        <v-icon class="mr-2" color="kbDarkBlueText">mdi-account-circle-outline</v-icon>
                        {{$t('general.event')}}
                    </v-tab>
                    <v-tab class="text-capitalize font-weight-medium kbDarkBlueText--text">
                        <v-icon class="mr-2" color="kbDarkBlueText">mdi-ticket</v-icon>
                        {{$t('general.buyer')}}
                    </v-tab>
                    <v-tab class="text-capitalize font-weight-medium kbDarkBlueText--text">
                        <v-icon class="mr-2" color="kbDarkBlueText">mdi-account-card-details-outline</v-icon>
                        {{$t('general.purchase')}}
                    </v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab">
                    <v-tab-item>
                        <v-list color="kbLight" two-line>
                            <v-list-item v-if="attendeeInfo.name">
                                <v-icon class="mr-4"
                                        :color="attendeeInfo.checkInState ? 'green' : 'red'">{{attendeeInfo.checkInState ? 'check' : 'clear'}}</v-icon>
                                <v-list-item-content>
                                    <v-list-item-title class="text-capitalize">
                                        {{attendeeInfo.checkInState ? $t('general.check') : $t('general.unCheck')}}
                                    </v-list-item-title>

                                    <v-list-item-subtitle>{{$t('general.checkInState')}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item v-if="attendeeInfo.name">
                                <v-icon color="kbDarkBlueText" class="mr-4">mdi-account</v-icon>
                                <v-list-item-content>
                                    <v-list-item-title class="text-capitalize">{{attendeeInfo.name}} {{ attendeeInfo.lastName }}</v-list-item-title>
                                    <v-list-item-subtitle>{{$t('general.name')}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item v-if="attendeeInfo.email">
                                <v-icon color="kbDarkBlueText" class="mr-4">mdi-email</v-icon>
                                <v-list-item-content>
                                    <v-list-item-title>{{attendeeInfo.email}}</v-list-item-title>
                                    <v-list-item-subtitle>{{$t('general.email')}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item v-if="attendeeInfo.phone[0]">
                                <v-icon color="kbDarkBlueText" class="mr-4">mdi-phone</v-icon>
                                <v-list-item-content>
                                    <v-list-item-title>{{attendeeInfo.phone.join(', ')}}</v-list-item-title>
                                    <v-list-item-subtitle>{{$t('general.phone')}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item v-if="attendeeInfo.document">
                                <v-icon color="kbDarkBlueText" class="mr-4">mdi-card-account-details-outline</v-icon>
                                <v-list-item-content>
                                    <v-list-item-title>{{attendeeInfo.document}}</v-list-item-title>
                                    <v-list-item-subtitle>{{$t('general.document')}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>

                        <v-list color="kbLight" v-if="attendeeInfo.qrCode">
                            <v-list-item>
                                <v-icon color="kbDarkBlueText" class="mr-4">fas fa-qrcode</v-icon>
                                <v-list-item-content>
                                    <v-list-item-title>{{$t('general.code')}} QR</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-img :src="attendeeInfo.qrCode" :alt="`${$t('general.code')} QR`" width="200"/>
                        </v-list>
                    </v-tab-item>

                    <v-tab-item>
                        <v-list color="kbLight" two-line v-if="attendeeInfo.eventTitle">
                            <v-list-item>
                                <v-icon color="kbDarkBlueText" class="mr-4">mdi-party-popper</v-icon>
                                <v-list-item-content>
                                    <v-list-item-title>{{ attendeeInfo.eventTitle }}</v-list-item-title>
                                    <v-list-item-subtitle>{{$t('general.event')}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item v-if="attendeeInfo.ticket.title">
                                <v-icon color="kbDarkBlueText" class="mr-4">mdi-ticket</v-icon>
                                <v-list-item-content>
                                    <v-list-item-title>{{ attendeeInfo.ticket.title }}</v-list-item-title>
                                    <v-list-item-subtitle>Ticket</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item v-if="attendeeInfo.ticket.type.code">
                                <v-icon color="kbDarkBlueText" class="mr-4">mdi-cash-multiple</v-icon>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        <span class="text-uppercase ml-1"
                                              v-if="attendeeInfo.purchase.payAmount && parseInt(attendeeInfo.purchase.payAmount) !== 0">
                                            {{ attendeeInfo.ticket.currency }}
                                        </span>
                                        {{ (attendeeInfo.ticket.type.code === 0) ? 'Gratis' : format2(attendeeInfo.purchase.payAmount, '$') }}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>{{$t('general.cost')}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                        </v-list>
                    </v-tab-item>

                    <v-tab-item>
                        <v-list color="kbLight" two-line>
                            <div v-if="attendeeInfo.purchase.paymentInfo">
                                <v-list-item v-if="attendeeInfo.purchase.paymentInfo.x_ref_payco">
                                    <v-icon color="kbDarkBlueText" class="mr-4">mdi-key-outline</v-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ attendeeInfo.purchase.paymentInfo.x_ref_payco }}</v-list-item-title>
                                        <v-list-item-subtitle>Ref Epayco</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>

                                <v-list-item v-if="attendeeInfo.purchase.paymentInfo.x_response">
                                    <v-icon color="kbDarkBlueText" class="mr-4" :class="epaycoResponse.color">{{ epaycoResponse.icon }}</v-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ attendeeInfo.purchase.paymentInfo.x_response }}</v-list-item-title>
                                        <v-list-item-subtitle>{{$t('general.parallelAnswer')}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>

                                <v-list-item v-if="attendeeInfo.purchase.paymentInfo.x_franchise">
                                    <img class="imagen-franquicia"
                                         :src="'https://storage.cloud.google.com/keybe/images/Franchises_Logos/' + attendeeInfo.purchase.paymentInfo.x_franchise + '.png?authuser=1'"
                                         :alt="$t('general.franchise')">
                                    <v-list-item-content>
                                        <v-list-item-title>{{ attendeeInfo.purchase.paymentInfo.x_franchise }}</v-list-item-title>
                                        <v-list-item-subtitle>{{$t('general.franchise')}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>

                                <v-list-item v-if="attendeeInfo.purchase.paymentInfo.x_bank_name">
                                    <v-icon color="kbDarkBlueText" class="mr-4">mdi-bank</v-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ attendeeInfo.purchase.paymentInfo.x_bank_name }}</v-list-item-title>
                                        <v-list-item-subtitle>{{$t('general.bank')}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>

                                <v-list-item v-if="attendeeInfo.purchase.paymentInfo.x_currency_code">
                                    <v-icon color="kbDarkBlueText" class="mr-4">mdi-cash-multiple</v-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <span class="text-uppercase mr-1">{{ attendeeInfo.purchase.paymentInfo.x_currency_code }}</span>
                                            {{(attendeeInfo.ticket.type.code === 0) ? 'Gratis' : format2(attendeeInfo.purchase.paymentInfo.x_amount, '$') }}
                                        </v-list-item-title>
                                        <v-list-item-subtitle>{{$t('general.value')}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>

                                <v-list-item v-if="attendeeInfo.purchase.paymentInfo.x_customer_ip">
                                    <v-icon color="kbDarkBlueText" class="mr-4">mdi-lan-connect</v-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>{{ attendeeInfo.purchase.paymentInfo.x_customer_ip }}</v-list-item-title>
                                        <v-list-item-subtitle>Ip {{$t('general.buyer')}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                                <template v-if="attendeeInfo.purchase.paymentInfo.provider === 'mercadopago' &&
                                  attendeeInfo.purchase.paymentInfo.paymentMethod === 'pse'">
                                  <v-list-item v-if="attendeeInfo.purchase.paymentInfo.charge.id">
                                      <v-icon color="kbDarkBlueText" class="mr-4">mdi-key-outline</v-icon>
                                      <v-list-item-content>
                                          <v-list-item-title>{{ attendeeInfo.purchase.paymentInfo.charge.id }}</v-list-item-title>
                                          <v-list-item-subtitle>Ref Mercadopago</v-list-item-subtitle>
                                      </v-list-item-content>
                                  </v-list-item>
                                  <v-list-item v-if="attendeeInfo.purchase.paymentInfo.charge.transaction_amount">
                                    <v-icon color="kbDarkBlueText" class="mr-4">mdi-cash-multiple</v-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <span class="text-uppercase ml-1">
                                                {{ attendeeInfo.purchase.paymentInfo.charge.currency_id }}
                                            </span>
                                            {{ (attendeeInfo.purchase.paymentInfo.charge.transaction_amount === 0) ? 'Gratis' :
                                              format2(attendeeInfo.purchase.paymentInfo.charge.transaction_amount, '$') }}
                                        </v-list-item-title>
                                        <v-list-item-subtitle>{{$t('general.cost')}}</v-list-item-subtitle>
                                    </v-list-item-content>
                                  </v-list-item>
                                </template>
                            </div>

                            <v-list-item v-if="attendeeInfo.purchase.createdAt">
                                <v-icon color="kbDarkBlueText" class="mr-4">mdi-calendar-clock</v-icon>
                                <v-list-item-content>
                                    <v-list-item-title>{{ attendeeInfo.purchase.createdAt | moment('DD/MM/YYYY hh:mma') }}</v-list-item-title>
                                    <v-list-item-subtitle>{{$t('general.date')}} {{$t('general.and')}} {{$t('general.hour')}}
                                        {{$t('general.ofPurchase')}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>

                        </v-list>
                    </v-tab-item>
                </v-tabs-items>

            </v-card-text>

            <v-card-text v-else>
                <v-row>
                    <v-col class="text-center" cols="12" v-if="loadingAttendee">
                        <v-progress-circular indeterminate color="kbDarkBlueText"></v-progress-circular>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="mr-2" color="red" outlined @click="toggleModal(false)" small>{{$t('general.close')}}</v-btn>
                <a v-if="attendeeInfo.purchase.status.code === 1" style="text-decoration: none" :href="attendeeInfo.urlDownload.url" target="_blank">
                    <v-btn color="kbGold" dark small>
                        <v-icon class="ml-2" small left>fas fa-qrcode</v-icon>
                        <span class="mr-2">{{$t('general.download')}} QR</span>
                    </v-btn>
                </a>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import notifications from '@/libs/notifications'
export default {
  computed: {
    ...mapState({
      selectedApp: state => state.apps.selectedApp,
      selectedUser: state => state.users.selectedUser
    }),
    epaycoResponse () {
      const responseCode = parseInt(this.attendeeInfo.purchase.paymentInfo.x_cod_response)
      switch (responseCode) {
        case 1: return {
          icon: 'mdi-check-bold',
          color: 'green--text'
        }
        case 2: return {
          icon: 'mdi-close-circle',
          color: 'red--text'
        }
        case 3: return {
          icon: 'mdi-clock-outline',
          color: 'gray-text'
        }
        default: return {
          icon: 'mdi-close-circle',
          color: 'red--text'
        }
      }
    }
  },
  data () {
    return {
      attendeeInfo: null,
      tab: 0,
      extradataSelectedForEdit: '',
      loadingAttendee: false,
      showButtons: '',
      showEditExtradataDialog: false,
      updatingExtradata: false
    }
  },
  methods: {
    showEditExtradata (extradata) {
      this.extradataSelectedForEdit = JSON.parse(JSON.stringify(extradata))
      this.showEditExtradataDialog = true
    },
    copyText (text) {
      navigator.clipboard.writeText(text).then(() => {
        notifications.success('Datos copiados en el portapapeles')
      }).catch(() => {
        notifications.error('Ocurrió un error, intenta nuevamente')
      })
    },
    submit () {
      this.updatingExtradata = true
      const extradata = [this.extradataSelectedForEdit]
      this.$store.dispatch('updateUserExtradata', { userId: this.selectedUser.UUID, extradata }).then((response) => {
        this.$store.commit('SET_SELECTED_USER', response.user)
        notifications.success('Información actualizada')
        this.updatingExtradata = false
        this.showEditExtradataDialog = false
        this.extradataSelectedForEdit = ''
      }).catch(error => {
        notifications.error(error.message)
        this.updatingExtradata = false
      })
    },
    toggleModal (value) {
      this.$emit('input', value)
    },
    transform (value) {
      try {
        return JSON.parse(value)
      } catch (error) {
        console.log(error)
      }
    },
    typeObject (value) {
      try {
        const element = JSON.parse(value)
        if (element instanceof Object) return 'object'
      } catch (error) {
        return 'string'
      }
    },
    format2 (n, currency) {
      n = Number(n)
      if (this.attendeeInfo.ticket.currency.toUpperCase() === 'COP') {
        n = currency + n.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
        n = n.replace('.00', '')
        return n
      }
      return currency + n.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
    }
  },
  props: ['value', 'attendee'],
  watch: {
    value (value) {
      if (value) {
        this.loadingAttendee = true
        this.$store.dispatch('getAttendeeInfo', { eventId: this.attendee.eventId, attendeeId: this.attendee._id }).then(response => {
          this.loadingAttendee = false
          this.attendeeInfo = response
        }).catch(error => {
          this.loadingAttendee = false
          notifications.error(error.message)
        })
      }
    }
  }
}
</script>

<style scoped>
    img.imagen-franquicia {
        margin: 0 10px 0 0;
        width: 30px;
    }
</style>
